var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advanced_Search",
    "data-name": "Advanced Search",
    transform: "translate(-502 -2156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(502 2156)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50724",
    "data-name": "Group 50724",
    transform: "translate(17 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(497.284 2299.284)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1930",
    "data-name": "Ellipse 1930",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(3.716 3.716)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1010",
    "data-name": "Line 1010",
    x1: 9.694,
    y1: 9.695,
    transform: "translate(26.022 26.021)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(497 2299)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.bb8c113342ca040777d7be75e7cfc696.svg";
export { ForwardRef as ReactComponent };